<template>
	<Modal
		:theme="$arenaConfig.isLightTheme ? null : 'dark'"
		class="payment__modal"
		modal-name="PaymentModal"
		:closeable="closeable"
		:render-only-when-active="true"
		data-testid="payment-modal"
		@opened="onOpen"
		@opening-animation-finished="onOpeningAnimationFinished"
	>
		<template #title>
			{{ $I18n.trans('payments.modal.title_' + mode ) }}
		</template>
		<template #content>
			<PaymentFlow
				ref="paymentFlow"
				:event="event"
				:auto-init="false"
				@closeable-change="closeable = $event"
			/>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import PaymentFlow from '@js/components/Payments/PaymentFlow.vue';

export default {
	name:       'PaymentModal',
	components: { Modal, PaymentFlow },
	props:      {
		event: {
			type:     Object,
			required: false,
			default:  null,
		},
	},
	data() {
		return {
			closeable:      true,
			pendingOptions: null,
		};
	},
	computed: {
		mode() {
			return this.event ? 'event' : 'subscription';
		},
	},
	methods: {
		onOpen(options) {
			this.pendingOptions = options || {};
			this.$nextTick(this.initializePaymentFlow);
		},
		onOpeningAnimationFinished() {
			this.initializePaymentFlow();
		},
		initializePaymentFlow() {
			if (!this.$refs.paymentFlow) {
				return;
			}

			this.$refs.paymentFlow.initialize(this.pendingOptions || {});
		},
	},
};
</script>
